import { render } from "./PreOptinDialogV2Preview.vue?vue&type=template&id=36d7ba38&scoped=true"
import script from "./PreOptinDialogV2Preview.vue?vue&type=script&lang=js"
export * from "./PreOptinDialogV2Preview.vue?vue&type=script&lang=js"

import "./PreOptinDialogV2Preview.vue?vue&type=style&index=0&id=36d7ba38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d7ba38"]])

export default __exports__